import "./tools.scss";
import m from "mithril";
import merge from "./merge";
import dbstore from "./dbstore";
// import anime from "animejs";
import JSON5 from "json5";
import {ulid} from "ulid";
import pf from "../pf";
import {
	Toaster,
	Dialog,
	ToasterPosition,
	Switch,
	Button,
	Icon,
	Icons,
	Size,
	Intent,
	Align,
	Input,
	Select,
	Spinner,
	TextArea,
	Checkbox,
	Tree,
	TreeNode,
	SelectList,
	ListItem,
	Popover,
	Menu,
	MenuItem,
	Classes,
	PopoverInteraction,
} from "../plugins/construct-ui/index";
import FLIP from "./flip";
// import infiniteselect from "./infinite-select";
import responsiveComponent from "../plugins/responsive-component/responsive-component";

const AppToaster = new Toaster();

const DialogDetail = {};

const StandardAPI = (appcode, code) => {
	return async (args) => {
		// console.log({args});
		return await pf.APIAction("StandardAPIFunction", {
			appcode,
			code,
			...args,
		});
	};
};

let observerPlayground = new IntersectionObserver((entries, observerRef) => {
	entries.forEach(async (entry) => {
		if (entry.isIntersecting) {
			observerRef.unobserve(entry.target);

			try {
			} catch (error) {
				console.error("Error loading playground-elements:", error);
			} finally {
				observerRef.disconnect();
			}
		}
	});
});

const tools = (
	x = {
		GetModifiers: (e) => {
			return {
				primary: e.ctrlKey || e.metaKey, // Ctrl (Win/Linux) or ⌘ (macOS)
				shift: e.shiftKey,
				alt: e.altKey,
			};
		},
		// LoadOnVisible: (el) => {
		// 	observerPlayground.observe(el);
		// },
		AreObjectsSame: (objA, objB, isStrict = false) => {
			let areTheSame = true;

			const strictLevel = isStrict ? "isStrict" : "isNotStrict";

			const valuesDoNotMatch = {
				isStrict: (a, b) => a !== b,
				isNotStrict: (a, b) => a != b,
			};

			const isObject = (a, b) => typeof a === "object" && !Array.isArray(a) && !!a && !!b;

			const compareArrays = (a, b) => {
				if (a.length === b.length) {
					a.sort();
					b.sort();

					a.forEach((ele, idx) => compareValues(ele, b[idx]));
				} else {
					areTheSame = false;
				}
			};

			const compareValues = (a, b) => {
				if (Array.isArray(a)) {
					compareArrays(a, b);
				} else if (!isObject(a, b) && valuesDoNotMatch[strictLevel](a, b)) {
					areTheSame = false;
				} else if (isObject(a, b) && !this.objectsAreTheSame(a, b, isStrict)) {
					areTheSame = false;
				}
			};

			const keysA = Object.keys(objA);
			const keysB = Object.keys(objB);

			if (keysA.length !== keysB.length) return false;

			for (let key of keysA) compareValues(objA[key], objB[key]);

			return areTheSame;
		},
		Wait: async (ms = 1000) => {
			return new Promise((resolve) => {
				setTimeout(resolve, ms);
			});
		},
		get ULID() {
			let _ulid = ulid();
			// console.log("requested ulid", {_ulid});
			return _ulid;
		},
		ToDateText: (dateStr) => {
			if (dateStr) {
				//  Convert a string like '2020-10-04T00:00:00' into '4/Oct/2020'
				let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
				let date = new Date(dateStr);
				// console.log({date, dateStr});

				let str = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
				return str;
			} else return dateStr;
		},
		LoadCommonAPIComponentForClass: (classname, element, inNodeOnly, ...additionalAttrs) => {
			let attrs = ["data-appcode", "data-apicode", "data-code", "data-hash"];
			let blockSelector = document.querySelectorAll(`${classname.includes(".") ? "" : "."}${classname}`);
			let parentSelector = document.querySelector("#mainContent");
			blockSelector.forEach((e) => {
				let attributes = {};
				attrs.forEach((a) => {
					attributes[a.replace("data-", "")] = e.getAttribute(a);
					e.removeAttribute(a);
				});
				e.classList.toggle(classname);
				m.mount(inNodeOnly ? e : parentSelector, {
					view: function () {
						return m(element, {
							...attributes,
							...additionalAttrs,
							api: async (args) => {
								return await pf.APIAction("StandardCommonAPI", {
									...attributes,
									...args,
								});
							},
						});
					},
				});
			});
		},

		StandardAPI: StandardAPI,
		LoadComponentForClassAsync: (classname, elementPath, attrs, ...additionalAttrs) => {
			console.log("trying to load component", {classname, elementPath});
			let blockSelector = document.querySelectorAll(`${classname.includes(".") ? "" : "."}${classname}`);
			if (blockSelector && blockSelector.length > 0) {
				import(elementPath).then((component) => {
					console.log({elementPath, component});
					blockSelector.forEach((e) => {
						let attributes = {};
						attrs.forEach((a) => {
							attributes[a.replace("data-", "")] = e.getAttribute(a);
						});
						e.classList.toggle(classname);
						m.mount(e, {
							view: function () {
								return m(component, {
									...attributes,
									...additionalAttrs,
								});
							},
						});
					});
				});
			}
		},
		LoadComponentForClass: (classname, element, attrs, ...additionalAttrs) => {
			let blockSelector = document.querySelectorAll(`${classname.includes(".") ? "" : "."}${classname}`);
			blockSelector.forEach((e) => {
				let attributes = {...e.dataset};
				// attrs.forEach((a) => {
				// 	attributes[a.replace("data-", "")] = e.dataset[a.replace("data-", "")];
				// });
				// console.log({e, attributes});
				//
				e.classList.toggle(classname);
				m.mount(e, {
					view: function () {
						return m(element, {
							...attributes,
							...additionalAttrs,
							api: async (args) => {
								return await pf.APIAction("StandardCommonAPI", {
									...attributes,
									...args,
								});
							},
						});
					},
				});
			});
		},
		LoadComponentForClassInFullPage: (classname, element, attrs, inNodeOnly, ...additionalAttrs) => {
			let blockSelector = document.querySelectorAll(`${classname.includes(".") ? "" : "."}${classname}`);
			let parentSelector = document.querySelector("#mainContent");
			blockSelector.forEach((e) => {
				let attributes = {};
				attrs.forEach((a) => {
					attributes[a.replace("data-", "")] = e.getAttribute(a);
					e.removeAttribute(a);
				});
				e.classList.toggle(classname);
				m.mount(inNodeOnly ? e : parentSelector, {
					view: function () {
						return m(element, {
							...attributes,
							...additionalAttrs,
						});
					},
				});
			});
		},
		LoadCustomClientComponentForClassInFullPage: (classname, element, inNodeOnly, ...additionalAttrs) => {
			let blockSelector = document.querySelectorAll(`${classname.includes(".") ? "" : "."}${classname}`);
			let parentSelector = document.querySelector("#mainContent");
			blockSelector.forEach(async (e) => {
				let attrs = ["data-appcode", "data-apicode", "data-blockcode"];
				let state = {};
				attrs.forEach((a) => {
					state[a.replace("data-", "")] = e.getAttribute(a);
					e.removeAttribute(a);
				});
				e.classList.toggle(classname);
				// let result = await StandardAPI(state.appcode, state.apicode)({ blockcode: state.blockcode });
				// if (result.success) {
				// 	state.data = { ...result.data };
				// 	const comp = () => {
				// 		return {
				// 			view: function () {
				// 				return m(element, {
				// 					state,
				// 					...additionalAttrs,
				// 				});
				// 			},
				// 		};
				// 	};
				// 	m.mount(inNodeOnly ? e : parentSelector, comp);
				// }

				const comp = () => {
					return {
						view: function () {
							return m(element, {
								GetState: async () => {
									let result = await StandardAPI(state.appcode, state.apicode)({blockcode: state.blockcode});
									if (result.success) {
										state.data = {...result.data};
										// console.log({ result, state });
										return {state, success: true};
									} else return {error: "Error in Fetching Data", success: false};
								},
								...additionalAttrs,
							});
						},
					};
				};
				m.mount(inNodeOnly ? e : parentSelector, comp);
			});
		},
		LoadClientComponentForClassInFullPage: (classname, element, inNodeOnly, ...additionalAttrs) => {
			let blockSelector = document.querySelectorAll(`${classname.includes(".") ? "" : "."}${classname}`);
			let parentSelector = document.querySelector("#mainContent");
			blockSelector.forEach(async (e) => {
				let attrs = ["data-appcode", "data-apicode", "data-blockcode"];
				let state = {};
				attrs.forEach((a) => {
					state[a.replace("data-", "")] = e.getAttribute(a);
					e.removeAttribute(a);
				});
				e.classList.toggle(classname);
				let result = await StandardAPI(state.appcode, state.apicode)({blockcode: state.blockcode});
				if (result.success) {
					state.data = {...result.data};
					const comp = () => {
						return {
							view: function () {
								return m(element, {
									state,
									...additionalAttrs,
								});
							},
						};
					};
					m.mount(inNodeOnly ? e : parentSelector, comp);
				}
			});
		},
		LoadIndependentComponent: (classname, element, attrs, inNodeOnly) => {
			let blockSelector = document.querySelectorAll(`${classname.includes(".") ? "" : "."}${classname}`);
			let parentSelector = document.querySelector("#mainContent");
			blockSelector.forEach((e) => {
				let state = {};

				let db = dbstore({}, () => {
					state = db.states();
				});
				attrs = [...attrs, "data-apicode", "data-appcode"];
				attrs.forEach((a) => {
					db.update({[a.replace("data-", "")]: e.getAttribute(a)});
					e.removeAttribute(a);
				});
				e.classList.toggle(classname);

				state.api = async (args, ...vals) => {
					console.log({args, vals});
					let result = await pf.APIAction("StandardProcessFunctions", {
						appcode: state.appcode,
						apicode: state.apicode,
						...args,
					});
					//console.log({args, vals, result});
					if (result.success) {
						if (vals)
							return vals.reduce((p, n) => {
								p[n] = result[n];
								return p;
							}, {});
						return result;
					} else return null;
				};
				state.update = db.update;

				m.mount(inNodeOnly ? e : parentSelector, {
					view: function () {
						return m(element, {
							state,
						});
					},
				});
			});
		},
		FilterUntil: (array = [], stop = () => true, cont = () => true) => {
			let shouldStop = false;
			let result = [];
			array.forEach((a) => {
				if (!shouldStop) {
					if (cont(a)) {
						if (stop(a)) {
							shouldStop = true;
						}
						if (!shouldStop) {
							result.push(a);
						}
					}
				}
			});
			return result;
		},
		ValidateJSON: (receivedJSON) => {
			let error = undefined;
			let json = undefined;
			try {
				json = JSON5.stringify(JSON5.parse(receivedJSON), {
					space: 2,
					quote: '"',
				});
			} catch (err) {
				json = receivedJSON;
				error = err.toString();
			}
			return {json, error};
		},
		WithPopOver: (trigger, popovercontent) => {
			return {
				...m(Popover, {
					closeOnEscapeKey: true,
					closeOnContentClick: false,
					content: popovercontent,
					hasArrow: true,
					hasBackdrop: false,
					inline: false,
					interactionType: "hover",
					openOnTriggerFocus: true,
					// position: this.position,
					trigger: trigger,
				}),
			};
		},

		// Animate: (entry, exit) => {
		// 	return {
		// 		oncreate: (v) => {
		// 			return new Promise((resolve) => {
		// 				anime({
		// 					targets: v.dom,
		// 					opacity: [0, 1],
		// 					duration: 3000,
		// 					easing: "spring(1, 80, 50, 0)",
		// 					complete: () => {
		// 						resolve();
		// 					},
		// 				});
		// 			});
		// 		},
		// 		onupdate: (v) => {},
		// 		onbeforeremove: (v) => {
		// 			return new Promise((resolve) => {
		// 				anime({
		// 					targets: v.dom,
		// 					opacity: [1, 0],
		// 					duration: 3000,
		// 					easing: "spring(1, 80, 50, 0)",
		// 					complete: () => {
		// 						resolve();
		// 					},
		// 				});
		// 			});
		// 		},
		// 	};
		// },
		Flip: (children, startduration = 1000, endduration = 1000, moveduration) => {
			return {
				...m(
					FLIP,
					{
						// enter: ({dom}, flip) => {
						// 	anime({
						// 		targets: dom,
						// 		opacity: [0, 1],
						// 		duration: startduration,
						// 	});
						// },
						move: (vnodeChild, flip) => {
							let flipBounding = flip.boundingClients[vnodeChild.key],
								diff = flipBounding.deltaY,
								anim = [
									{transform: "translate3d(0," + diff + "px,0)", opacity: 0},
									{transform: "translate3d(0,0,0)", opacity: 1},
								];

							vnodeChild.dom.animate(anim, {
								duration: 1000,
							});
						},
						// exit: ({dom}, flip) => {
						// 	return new Promise((resolve) => {
						// 		anime({
						// 			targets: dom,
						// 			opacity: [1, 0],
						// 			duration: endduration,
						// 			complete: resolve,
						// 		});
						// 	});
						// },
					},
					children.map((a) => {
						if (!a.key) a.key = Date.now();
						return a;
					})
				),
			};
		},
		Icon: (icon, options) => {
			return {...m(Icon, {name: icon, ...options})};
		},
		AdminHeader: (url, title, confirmation) => {
			return {
				...m(
					".admin-header",
					{
						style: `display: grid; grid-template-columns: auto 1fr; border-bottom: 1px solid lightgray;`,
					},
					[
						x.Button(undefined, Icons.ARROW_LEFT, undefined, () => {
							if (confirmation) {
								x.ConfirmDiscard().then((r) => {
									if (r) x.GoToAbsoluteURL(url);
								});
							} else {
								x.GoToAbsoluteURL(url);
							}
						}),
						x.Label(title, undefined, "font-size: 2rem; text-align:center;"),
					]
				),
			};
		},
		MyDialog: () => {
			return {
				...m(Dialog, {
					class: "full-width",
					autofocus: true,
					basic: true,
					closeOnEscapeKey: DialogDetail.allowEsc,
					closeOnOutsideClick: DialogDetail.allowEsc,
					content: DialogDetail.content,
					hasBackdrop: true,
					isOpen: DialogDetail.isOpen,
					inline: false,
					onClose: DialogDetail.onClose,
					title: DialogDetail.title,
					transitionDuration: 200,
					footer: DialogDetail.footer,
				}),
			};
		},
		ShowDialog: (title, allowEsc, content, footer, isOpen, onClose) => {
			DialogDetail.title = title;
			DialogDetail.allowEsc = allowEsc;
			DialogDetail.content = content;
			DialogDetail.footer = footer;
			DialogDetail.isOpen = isOpen;
			DialogDetail.onClose = onClose;
		},
		HideDialog: () => {
			DialogDetail.isOpen = false;
		},
		ConfirmDiscard: async () => {
			return new Promise((resolve) => {
				x.ShowDialog(
					"Discard Changes",
					false,
					m("span", "Would you like to dicard changes?"),
					[
						x.Button(
							"Yes. Discard.",
							undefined,
							undefined,
							() => {
								x.HideDialog();
								resolve(true);
							},
							undefined,
							{
								intent: Intent.NEGATIVE,
							}
						),
						x.Button(
							"No. Stay.",
							undefined,
							undefined,
							() => {
								x.HideDialog();
								resolve(false);
							},
							undefined
						),
					],
					true
				);
			});
		},
		MyToaster: () => {
			return {
				...m(AppToaster, {
					clearOnEscapeKey: true,
					inline: false,
					position: ToasterPosition.TOP,
				}),
			};
		},
		Notify: (message, icon, timeout = 3000, intent) => {
			AppToaster.show({
				message,
				icon,
				intent: intent || Intent.NONE,
				size: Size.LG,
				timeout,
			});
		},
		debounce: (func, delay) => {
			let debounceTimer;
			return function () {
				const context = this;
				const args = arguments;
				clearTimeout(debounceTimer);
				debounceTimer = setTimeout(() => func.apply(context, args), delay);
			};
		},
		Spacer: (remwidth) => {
			return {...m("", {style: `width:${remwidth || 1}rem;`})};
		},

		SpacerVertical: (remheight) => {
			return {
				...m("", {style: `padding:${remheight / 2 || 0.5}rem;`}),
			};
		},
		Label: (text, remwidth, styletext) => {
			return {
				...m(
					"span",
					{
						style: `display: inlin-block; align-self: center; ${remwidth ? `width: ${remwidth}rem;` : ""} ${styletext}`,
					},
					text
				),
			};
		},
		URL: (state, page, q, parameters) => {
			let currentObj = {
				page: state.url.page,
				q: state.url.q,
				qs: state.url.qs,
			};

			let newObj = merge(currentObj, {
				page,
				q,
				qs: parameters,
			});

			let qs = "";
			if (newObj.qs) {
				qs = m.buildQueryString(newObj.qs);
				if (qs) qs = `?${qs}`;
			}

			if (!newObj.page) newObj.page = "";
			if (!newObj.q) newObj.q = "";

			return `${state.appcode}${newObj.page && "/"}${newObj.page}${newObj.q && "/"}${newObj.q}${qs}`;
		},
		GoToURL: (state, page, q, parameters) => {
			window.location.href = x.URL(state, page, q, parameters);
		},
		GoToInternalURL: (url) => {
			m.route.set(url);
		},
		GoToAbsoluteURL: (url) => {
			window.location.href = url;
		},
		Link: (text, leftIcon, rightIcon, location, options) => {
			return {
				...m(m.route.Link, {class: "standard-link", href: location, ...options}, [
					leftIcon &&
						m(Icon, {
							intent: Intent.NONE,
							name: leftIcon,
							size: Size.DEFAULT,
						}),
					text,
					rightIcon &&
						m(Icon, {
							intent: Intent.NONE,
							name: rightIcon,
							size: Size.DEFAULT,
						}),
				]),
			};
		},
		LinkButton: (text, leftIcon, rightIcon, location, options) => {
			return {
				...m(Button, {
					align: Align.CENTER,
					active: true,
					basic: false,
					compact: true,
					disabled: false,
					label: text,
					sublabel: null,
					loading: false,
					fluid: false,
					iconLeft: leftIcon,
					iconRight: rightIcon,
					intent: Intent.PRIMARY,
					rounded: false,
					outlined: false,
					size: Size.DEFAULT,
					href: location,
					...options,
				}),
			};
		},
		Button: (text, leftIcon, rightIcon, onclick, secondary, options, loading = false) => {
			return {
				...m(Button, {
					align: Align.CENTER,
					active: true,
					basic: false,
					compact: true,
					disabled: false,
					label: text,
					sublabel: null,
					loading: loading,
					fluid: false,
					iconLeft: leftIcon,
					iconRight: rightIcon,
					intent: secondary ? Intent.NONE : Intent.PRIMARY,
					rounded: false,
					outlined: false,
					size: Size.DEFAULT,
					onclick: onclick,
					...options,
				}),
			};
		},
		ClearButton: (text, leftIcon, rightIcon, onclick, options) => {
			return {
				...m(
					m.route.Link,
					{
						class: "standard-link",
						href: location,
						onclick,
						...options,
					},
					[
						leftIcon &&
							m(Icon, {
								intent: Intent.NONE,
								name: leftIcon,
								size: Size.DEFAULT,
							}),
						text,
						rightIcon &&
							m(Icon, {
								intent: Intent.NONE,
								name: rightIcon,
								size: Size.DEFAULT,
							}),
					]
				),
			};
		},
		Spinner: (message) => {
			return m(Spinner, {
				active: true,
				fill: false,
				intent: Intent.DEFAULT,
				size: Size.DEFAULT,
				message: message,
			});
		},
		Tree: (nodes, onclick) => {
			return {
				...m(Tree, {
					nodes: nodes,
					onClick: onclick,
				}),
			};
		},
		TreeNode: (id, text, icon, isSelected, onclick, menuactions, children) => {
			return {
				...m(TreeNode, {
					contentLeft:
						icon &&
						m(Icon, {
							name: icon,
						}),
					contentRight:
						menuactions &&
						menuactions.length > 0 &&
						m(Popover, {
							hasArrow: false,
							class: Classes.POPOVER_MENU,
							closeOnContentClick: true,
							content: m(Menu, [
								menuactions.map((ma) => {
									return m(MenuItem, {
										iconLeft: ma.icon,
										label: ma.text,
										onclick: ma.onclick,
									});
								}),
							]),
							position: "bottom-end",
							trigger: m(Icon, {
								name: Icons.MORE_HORIZONTAL,
							}),
						}),
					children: children,
					hasCaret: children && children.length > 0,
					label: text,
					key: id,
					isExpanded: true,
					isSelected: isSelected,
					onClick: onclick,
				}),
			};
		},
		TextArea: (text, onedit, options) => {
			if (!options) options = {};
			return {
				...m(TextArea, {
					value: text,
					basic: false,
					disabled: false,
					fluid: true,
					intent: MenuItem.DEFAULT,
					size: Size.XS,
					// placeholder: "Placeholder...",
					// readonly: false,
					//oninput: onedit,
					oninput: (e) => {
						if (onedit) onedit(e.target.value);
					},
					...options,
				}),
			};
		},
		TextAreaField: (title, text, onedit, options) => {
			return WithField(title, x.TextArea(text, onedit, options));
		},
		Text: (text, onedit, placeholder, iconLeft, iconRight, options) => {
			// console.log("icon right", iconRight);
			if (!options) options = {};
			return {
				...m(Input, {
					basic: false,
					contentLeft: iconLeft,
					contentRight: iconRight,
					disabled: false,
					fluid: true,
					intent: Intent.NONE,
					placeholder: placeholder,
					readonly: false,
					size: Size.XS,
					value: text,
					oninput: (e) => {
						if (onedit) onedit(e.target.value);
					},
					...options,
				}),
			};
		},
		CapitalizeFirstLetter: (string) => {
			if (string) return string.charAt(0).toUpperCase() + string.slice(1);
		},
		TextField: (title, text, onedit, placeholder, iconLeft, iconRight, labelwidthrem, description, ...options) => {
			return WithField(
				title,
				x.Text(text, onedit, placeholder, iconLeft, iconRight, ...options),
				labelwidthrem,
				description
			);
		},
		DropDown: (selectedItem, itemList, loading, search, onselect, placeholder, multiple, options) => {
			if (!itemList) itemList = [];

			itemList = itemList.map((a) => {
				return {
					id: a?.id || a?.text || a,
					name: a?.text || a?.name || a?.id || a,
				};
			});
			selectedItem = itemList.find((a) => a.id == (selectedItem?.id || selectedItem?.text || selectedItem));

			return {
				...m(SelectList, {
					closeOnSelect: true,
					header: undefined,
					multiple: multiple,
					footer: undefined,
					items: itemList,
					itemRender: (item) => {
						return m(ListItem, {
							//contentRight: m("", {style: `color:${Colors.BLUE_GREY200}`}, item.code),
							label: item.name,
							size: Size.XS,
							selected: item.id === selectedItem?.id,
						});
					},
					itemPredicate: (query, item) => {
						return item.name.toLowerCase().includes(query.toLowerCase());
					},
					onSelect: onselect,
					size: Size.XS,
					loading: loading,
					fluid: true,
					inline: true,
					position: "bottom-start",
					popoverAttrs: {
						hasArrow: false,
					},
					trigger: m(Button, {
						align: "left",
						size: Size.XS,
						compact: true,
						iconRight: Icons.CHEVRON_DOWN,
						outlined: true,
						//sublabel: placeholder,
						label: selectedItem ? selectedItem?.name : placeholder || "...",
						// style: "min-width: 5rem;",
						fluid: true,
						...options,
					}),
					...options,
				}),
			};
		},
		DropDownField: (caption, selectedItem, options, loading, search, onselect, placeholder, multiple) => {
			options = options.map((a) => {
				return {
					id: a.id || a.text || a,
					name: a.text || a.name || a.id || a,
				};
			});
			if (selectedItem) selectedItem = options.find((a) => a.id == (selectedItem?.id || selectedItem));

			return WithField(caption, x.DropDown(selectedItem, options, loading, search, onselect, placeholder, multiple));
		},
		GetAttibutes: (elem, ...args) => {
			let obj = {};
			for (let i = 0; i < args.length; i++) {
				obj[args[i]] = elem.getAttribute(args[i]);
			}
			return obj;
		},
		CheckBox: (checked, caption, readonly, onchange, options) => {
			return {
				...m(Checkbox, {
					checked: checked,
					label: caption,
					intent: Intent.NONE,
					readonly: readonly,
					size: Size.XS,
					onchange: (e) => {
						if (onchange) onchange(e.target.checked);
					},
					...options,
				}),
			};
		},
		CheckBoxField: (checked, caption, readonly, onchange) => {
			return WithField(caption, x.CheckBox(checked, undefined, readonly, onchange));
		},
		InfiniteSelect: (selectedItem, getdatafunction, onselect, placeholder, multiple) => {},
		InfiniteSelectField: (caption, selectedItem, getdatafunction, onselect, placeholder, multiple) => {
			return WithField(caption, x.InfiniteSelect(selectedItem, getdatafunction, onselect, placeholder, multiple));
		},
		HashFast: (str, seed = 0) => {
			// const cyrb53 = (str, seed = 0) => {
			let h1 = 0xdeadbeef ^ seed,
				h2 = 0x41c6ce57 ^ seed;
			for (let i = 0, ch; i < str.length; i++) {
				ch = str.charCodeAt(i);
				h1 = Math.imul(h1 ^ ch, 2654435761);
				h2 = Math.imul(h2 ^ ch, 1597334677);
			}

			h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
			h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);

			return 4294967296 * (2097151 & h2) + (h1 >>> 0);
			// };
		},
	}
) => x;

const fieldgroup = () => {
	let css = "display: grid;";
	return {
		view: (v) => {
			return m(
				responsiveComponent,
				{
					class: "field-group",
					style: `display: grid;`,
					OnWidthChange: (w) => {
						// console.log(w);
						if (w < 300) css = `display: grid;`;
						else {
							css = `display: grid; grid-template-columns: ${v.attrs.labelwidthrem}rem 1fr;`;
						}
						m.redraw();
					},
				},
				[
					m(
						"label",
						{
							style: css,
						},
						[
							v.attrs.title,
							m(".content-section", [v.attrs.content, v.attrs.description && m(".description", v.attrs.description)]),
						]
					),
				]
			);
		},
	};
};

function WithField(title, content, labelwidthrem = 20, description) {
	return m(fieldgroup, {
		title,
		content,
		labelwidthrem,
		description,
	});
	// return {
	// 	...m(
	// 		"label",
	// 		{
	// 			style: `display: flex; justify-content:stretch; flex-wrap: wrap; `,
	// 		},
	// 		[
	// 			m(
	// 				"span",
	// 				{
	// 					style: `flex: 1 1 ${labelwidthrem}rem;`,
	// 				},
	// 				title
	// 			),
	// 			m("", {style: `flex: 1 1 40rem;`}, content),
	// 		]
	// 	),
	// };
}

const myTools = tools();

export default myTools;
